<template>
    <div class="wrap" :class="{ 'is-first': isFirstRun, 'is-repeat': !isFirstRun, 'is-qoo10': $store.state.hostName === 'Q', 'no-animation': $store.state.hostName === 'Q' }">
        <transition name="grid-accordion" appear>
            <ul class="grid" v-show="gridShown">
                <li v-for="(item, index) in brandGrid" :key="'brandGrid-' + index">
                    <a :href="item[$store.state.hostName]" class="card">
                        <img :src="item.imageURL" :alt="item.brand || ''">
                        <p class="label">{{ item.brand }}</p>
                    </a>
                </li>
            </ul>
        </transition>
    </div>
</template>

<script>
const SESSION_KEY = 'rb-initial-loader-done'

export default {
  name: 'BrandGrid',

  data () {
    return {
      gridShown: false,
      isFirstRun: false
    }
  },

  computed: {
    brandGrid () {
      const list = this.$store.state.json.brandGrid || []
      return list.slice(0, 15)
    }
  },

  mounted () {
    const isQoo10 = this.$store.state.hostName === 'Q'

    // Qoo10 はアニメーション無効（即表示）
    if (isQoo10) {
      this.gridShown = true
      return
    }

    this.isFirstRun = !sessionStorage.getItem(SESSION_KEY)

    /**
     * 初回：InitialLoader と被らないように遅め
     * 2回目以降：早めに開始（ただし突然出ない程度の余裕は残す）
     */
    const showDelay = this.isFirstRun ? 1800 : 350

    setTimeout(() => {
      this.gridShown = true
    }, showDelay)
  }
}
</script>

<style lang="scss" scoped>
/**
 * 初回/2回目以降でアニメ時間を切替
 * - 2回目以降（デフォルト）：短め
 * - 初回（.is-first）：長め
 */
.wrap {
    --grid-maxh-duration: 1200ms;
    --grid-opacity-duration: 300ms;
    --grid-maxh: 2000px;

    &.is-first {
        --grid-maxh-duration: 2500ms;
        --grid-opacity-duration: 500ms;
    }

    &.is-qoo10 {
        padding-bottom: 0;
    }
}

.grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 4px;

    @media screen and (max-width: 722px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media screen and (min-width: 723px) and (max-width: 963px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media screen and (min-width: 964px) and (max-width: 1523px) {
        grid-template-columns: repeat(5, 1fr);
    }

    @media screen and (min-width: 1524px) and (max-width: 2286px) {
        grid-template-columns: repeat(5, 1fr);
    }

    @media screen and (min-width: 2287px) {
        grid-template-columns: repeat(5, 1fr);
    }
}

.card {
    position: relative;
    display: block;
    overflow: hidden;
}

.card img {
    display: block;
    width: 100%;
    height: auto;
}

.label {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.2;
    color: #ffffff;
    text-align: center;
    background: rgba(0, 0, 0, 20%);

    @media screen and (max-width: 722px) {
        font-size: 16px;
    }
}

/* アコーディオン展開（上→下） */
.grid-accordion-enter-active,
.grid-accordion-leave-active {
    overflow: hidden;
    transition:
        max-height var(--grid-maxh-duration) ease,
        opacity var(--grid-opacity-duration) ease;
    will-change: max-height, opacity;
}

.grid-accordion-enter,
.grid-accordion-leave-to {
    max-height: 0;
    opacity: 0;
}

/* 実表示より大きい上限を設定 */
.grid-accordion-enter-to,
.grid-accordion-leave {
    max-height: var(--grid-maxh);
    opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
    .grid-accordion-enter-active,
    .grid-accordion-leave-active {
        transition: none;
    }
}

.no-animation .grid-accordion-enter-active,
.no-animation .grid-accordion-leave-active {
    transition: none !important;
}

</style>
